import React from "react";
import { useTranslation } from "react-i18next";
import LocalizedLink from "../LocalizedLink/LocalizedLink";
import Services from "../../api/Services";
import { Image } from "@imagekit/react";

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const ServiceSectionS2 = (props) => {
    const { t } = useTranslation(["home", "services"]);
    return (
        <section className="service-section-s2 section-padding">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-7 col-12">
                        <div className="section-title">
                            <h2>{t("home:services.title")}</h2>
                            <h3>{t("home:services.subtitle")}</h3>
                        </div>
                    </div>
                </div>
                <div className="service-wrap">
                    <div className="row">
                        {Services.map((service, sitem) => (
                            <div className="col-xl-6 col-lg-6 col-md-6 col-12" key={sitem}>
                                <div className="service-card">
                                    <div className="top-number">
                                    </div>
                                    <div className="icon">
                                        <span>{service.Id}</span>
                                    </div>
                                    <div className="text ">
                                        <h2>{t(`services:${service.slug}.title`)}</h2>
                                        <p className="overflow-hidden" style={{maxHeight:"90px"}}>{t(`services:${service.slug}.shortDescription`)}</p>
                                        <LocalizedLink onClick={ClickHandler} to={`/service-single/${service.slug}`}>{t("home:hero.discover")}</LocalizedLink>
                                    </div>
                                    <div className="image">
                                           <Image
                                                src={service.sImg}
                                                transformation={[
                                                    {
                                                    width: "415",
                                                    height: "369",
                                                    crop: "maintain_ratio",
                                                    focus: "auto",
                                                    },
                                                ]}
                                                alt={t(`services:${service.slug}.title`)}
                                            />
                                        <h2 className="img-title">{t(`services:${service.slug}.title`)}</h2>
                                    </div>
                                </div>
                            </div>
                        )) }

                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServiceSectionS2;